import axios from 'axios';
import {backendHost} from '../../config';

export const getBonusCodeByid = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/bonus-code/${params.id}`);
};